var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankJeonbuk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 23,
    rx: 3,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10834_57027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 2.5H7V20.4999H25V2.5Z",
    fill: "#0091D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 2.5L11.4988 7.00196L15.9997 2.50054L7 2.5Z",
    fill: "#0091D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 2.5V11.4991L11.4988 7.00196L7 2.5Z",
    fill: "#009AD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 11.501L11.5015 7L7 11.5014L15.9998 11.501Z",
    fill: "#0091D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9983 11.4991V2.5L11.5 6.99818L15.9983 11.4991Z",
    fill: "#0082C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 2.5V11.4991L20.4988 7.00196L16 2.5Z",
    fill: "#0070BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9996 11.501L20.5009 7L16 11.5014L24.9996 11.501Z",
    fill: "#004C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5L11.4988 16.0019L15.9997 11.5005L7 11.5Z",
    fill: "#0082C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5V20.5007L11.4988 16.0024L7 11.5Z",
    fill: "#0070BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 20.5019L11.5015 16L7 20.5013L15.9998 20.5019Z",
    fill: "#0066B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9983 20.4991V11.5L11.5 15.9973L15.9983 20.4991Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.5L20.4988 16.0019L24.9997 11.5005L16 11.5Z",
    fill: "#1A3282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.5V20.5007L20.4988 16.0024L16 11.5Z",
    fill: "#004C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9996 20.5019L20.5009 16L16 20.5014L24.9996 20.5019Z",
    fill: "#1A3282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9987 20.4991V11.5L20.5 15.9973L24.9987 20.4991Z",
    fill: "#1A3282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 2.5L20.4988 7.00196L24.9997 2.50054L16 2.5Z",
    fill: "#0066B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9987 11.4991V2.5L20.5 6.99818L24.9987 11.4991Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 13.7556L19.2374 8.26562L10.4922 17.0339L13.6826 20.2243L19.2374 14.7526L24.9998 20.4841V13.7556Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10834_57027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankJeonbuk);
export default __webpack_public_path__ + "static/media/BankJeonbuk.e9d180663d9106bef90aa393e16e99db.svg";
export { ForwardRef as ReactComponent };